module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Progreso del proyecto\" ng-click=\"$ctrl.verRegistro()\">\n  <i class=\"fa fa-stack-overflow\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/timeline/button.html
// module id = 729
// module chunks = 0